"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f33 = void 0;
exports.f33 = {
    "!hu": [
        3843
    ],
    "!khung": [
        3843
    ],
    "!ku": [
        3843,
        8052
    ],
    "!kung": [
        3843,
        8052
    ],
    "!xu": [
        3843
    ],
    "!xun": [
        3843,
        4006,
        8052
    ],
    "!xung": [
        3843
    ],
    "!kora": [
        3924
    ],
    "!ora": [
        3924
    ],
    "!xo": [
        4006,
        5576
    ],
    "!xóõ": [
        5576
    ],
    "!khong": [
        5576
    ],
    "!xo’o~": [
        5576
    ],
    "!o!kung": [
        8052
    ],
    "!o!ung": [
        8052
    ],
    "!’o!xun": [
        8052
    ],
    "!’o-!khung": [
        8052
    ],
    "!kham": [
        8400
    ],
    "!hukwe": [
        8684
    ]
};
